// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bgv7","left":"styles_left__OBAaH"};